import { Component, OnInit, Input, ViewEncapsulation, ElementRef, AfterViewInit, Output, EventEmitter, HostListener } from '@angular/core';


@Component({
  selector: 'app-icons',
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.css'],
  encapsulation: ViewEncapsulation.None // It makes the normal css to work in dom objects also.
})

export class IconsComponent implements AfterViewInit, OnInit {

  // Inputs and output datas from and to app-body-component
  @Input() formatTypeDetails: any;
  @Input() formatSizeDetails: any;
  @Output() getTypeSize = new EventEmitter();

  // Global name variable to make easy communication
  name;


  // this method envokes on click on a format category.
  public openSize(name, e) {

    // To stop window click event for this function
    e.stopPropagation();

    // local variables
    let str;
    let temp;

    // Making global variable name is in same format as it is stored in our json file.
    this.name = name.toLowerCase().replace(' ', '').replace('-', '');

    // making all format types unselected and hide the format size option
    for (let j = 0; j < document.getElementsByClassName('thumbnail').length; j++) {
      document.getElementsByClassName('thumbnail')[j].classList.remove('thumbnail-item');
      document.getElementsByClassName('arrow')[j].classList.add('arrow-hide');
      document.getElementsByClassName('size-container')[j].classList.add('arrow-hide');
    }   

    // Conditions for checkining format types
    if (this.name === 'videoads') {
      this.sendName('videoads', 'videoads'); // Sending format type & size data to send sendname(type, size) method
      this.el.nativeElement.children[0].children[0].classList.add('thumbnail-item'); // For making it active icon
    } else if (this.name === 'nativeads') {
      this.sendName('nativeads', 'nativeads'); // Sending format type & size data to send sendname(type, size) method
      this.el.nativeElement.children[0].children[0].classList.add('thumbnail-item'); // For making it active icon
    }
    else if(this.name ==='desktopads' && window.innerWidth<768){
      this.name = name.toLowerCase().replace(' ', '').replace('-', '');
      str = '<div style="pointer-events:none">';
        str += '<h4 id="sorrytext">Sorry, the Desktop demo is unavailable in mobile devices</h4></div>';
      str += '<div>';
        this.el.nativeElement.children[0].children[0].classList.add('thumbnail-item'); // For making it active icon
        this.el.nativeElement.children[0].children[3].classList.remove('arrow-hide'); // For making arrow visible
        this.el.nativeElement.children[0].children[4].classList.remove('arrow-hide'); // For making size-container visible
        this.el.nativeElement.children[0].children[3].style.display = 'block'; // For making arrow display to block
        this.el.nativeElement.children[0].children[4].style.display = 'block'; // For making size-container display to block
        this.el.nativeElement.children[0].children[4].innerHTML = str; // Adding html content to the size-container
        document.getElementById('paragraphId').style.opacity = '0.5';

        // Binding click event to all of the generated icons under size-container
        temp = this.el.nativeElement.children[0].children[4].children[0];
        for (let i = 0; i < this.formatSizeDetails[this.name].length; i++) {
          temp.children[i].addEventListener('click',  (event: Event) => {
          this.sendName(this.formatSizeDetails[this.name][i].title, name); });
        }
      console.log('this is mobile');
    }
    else {
      this.name = name.toLowerCase().replace(' ', '').replace('-', '');
      str = '<div class="gride">';
      for (let i = 0; i < this.formatSizeDetails[this.name].length; i++) {
        str += '<div class="moduler"><div class="cover-svg">' +
        '<svg viewBox="0, 0, 140, 140">' + this.formatSizeDetails[this.name][i].svg + '</svg></div>' +
        '<label  class="size-label">' + this.formatSizeDetails[this.name][i].title + '</label></div>';
      }
      str += '<div>';
        this.el.nativeElement.children[0].children[0].classList.add('thumbnail-item'); // For making it active icon
        this.el.nativeElement.children[0].children[3].classList.remove('arrow-hide'); // For making arrow visible
        this.el.nativeElement.children[0].children[4].classList.remove('arrow-hide'); // For making size-container visible
        this.el.nativeElement.children[0].children[3].style.display = 'block'; // For making arrow display to block
        this.el.nativeElement.children[0].children[4].style.display = 'block'; // For making size-container display to block
        this.el.nativeElement.children[0].children[4].innerHTML = str; // Adding html content to the size-container
        document.getElementById('paragraphId').style.opacity = '0.5';

        // Binding click event to all of the generated icons under size-container
        temp = this.el.nativeElement.children[0].children[4].children[0];
        for (let i = 0; i < this.formatSizeDetails[this.name].length; i++) {
          temp.children[i].addEventListener('click',  (event: Event) => {
          this.sendName(this.formatSizeDetails[this.name][i].title, name); });
        }
    }
  }

  // Send the data using @output decorator to its parent
  public sendName(size, formatType) {
    const teststr = formatType + '-' + size;
    this.getTypeSize.emit(teststr);
    return this.name;
  }


  // Adding elementRef variable which is needed for referring the current element in angular
  // Adding local variable to constructor to use that in the class.
  constructor(private el: ElementRef) {
  }


  ngAfterViewInit() {
  }

  ngOnInit() {

    // Adding window addeventlistener to make whole body clickable to make default changes when clicked anywhere else in the body.
    window.addEventListener('click', () => {
      for (let j = 0; j < document.getElementsByClassName('arrow').length; j++) {
        document.getElementsByClassName('arrow')[j].classList.add('arrow-hide');
        document.getElementsByClassName('size-container')[j].classList.add('arrow-hide');
        document.getElementById('paragraphId').style.opacity = '1';
      }
    });

    if(/iPhone/.test(navigator.userAgent) == true){
      document.getElementById('appbodycontainer').addEventListener('click',function(){
        for (let j = 0; j < document.getElementsByClassName('arrow').length; j++) {
          document.getElementsByClassName('arrow')[j].classList.add('arrow-hide');
          document.getElementsByClassName('size-container')[j].classList.add('arrow-hide');
          document.getElementById('paragraphId').style.opacity = '1';
        }  
      });
    }

  }

}



// WEBPACK FOOTER //
// /home/ubuntu/demo.airtory.com-stage/src/app/icons/icons.component.ts